export default "/images/0575ffc13cc95d9d1e820488618145b8.avif";